<template>
  <div class="header-basket" @click="function(){$router.push({ name: 'basket' })}">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M15.8125 15.8125H5.99844L3.60078 2.62969C3.57273 2.47182 3.49038 2.32871 3.36797 2.22514C3.24556 2.12157 3.09081 2.06404 2.93047 2.0625H1.375" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.875 19.25C7.82424 19.25 8.59375 18.4805 8.59375 17.5312C8.59375 16.582 7.82424 15.8125 6.875 15.8125C5.92576 15.8125 5.15625 16.582 5.15625 17.5312C5.15625 18.4805 5.92576 19.25 6.875 19.25Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.8125 19.25C16.7617 19.25 17.5312 18.4805 17.5312 17.5312C17.5312 16.582 16.7617 15.8125 15.8125 15.8125C14.8633 15.8125 14.0938 16.582 14.0938 17.5312C14.0938 18.4805 14.8633 19.25 15.8125 19.25Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.37109 12.375H16.1648C16.4862 12.376 16.7977 12.2636 17.0444 12.0578C17.2912 11.8519 17.4575 11.5656 17.5141 11.2492L18.5625 5.5H4.125" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="counter-indicator">
      <span class="value">{{hb_qnt}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBasket',
  props : {
    hb_qnt : Number
  },
  components: {

  },
  data() {
    return{

    }
  },
  methods : {

  }
}
</script>

<style scoped>
.header-basket {
  display: flex;
  cursor: pointer;
  position: relative;
}

.counter-indicator {
  position: absolute;
  top: -9px;
  right: -9px;
  height: 19px;
  width: 19px;
  background: var(--Blue, #1B78BC);
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--White, #FFF);
}

.counter-indicator .value{
  color: var(--White, #FFF);
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>